import type { LocalizedString } from '@/shared/schemas/operation-data.zod'

/**
 * Resolves a potentially localized string to a plain string.
 * 
 * If the value is a string, returns it directly.
 * If the value is an object (LocalizedString), returns the value for the current locale,
 * falling back to 'en' then to the first available value.
 * 
 * @param value - A string or LocalizedString object
 * @param locale - The current locale (defaults to 'en')
 * @returns The resolved string value
 */
export function resolveLocalizedString(
  value: string | LocalizedString | undefined | null,
  locale: string = 'en'
): string {
  if (!value) return ''
  if (typeof value === 'string') return value
  // It's a LocalizedString object
  if (value[locale]) return value[locale]
  if (value['en']) return value['en']
  // Return first available value
  const keys = Object.keys(value)
  return keys.length > 0 ? value[keys[0]] : ''
}
